import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// API Base URL
export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// API Helper
export async function apiRequest(endpoint, options = {}) {
  const token = localStorage.getItem('adminToken');
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: 'Request failed' }));
    throw new Error(error.detail || 'Request failed');
  }

  return response.json();
}

// Format price
export function formatPrice(price) {
  return new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD',
    minimumFractionDigits: 0,
  }).format(price);
}

// Format date
export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-NZ', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

// Tag colors mapping
export const tagColors = {
  'Covered': 'bg-blue-100 text-blue-700',
  'Uncovered': 'bg-orange-100 text-orange-700',
  'Slide Included': 'bg-purple-100 text-purple-700',
  'Wet Use': 'bg-cyan-100 text-cyan-700',
  'Dry Use': 'bg-amber-100 text-amber-700',
  'Most Popular': 'bg-red-100 text-red-700',
};

// Booking status colors
export const statusColors = {
  'new_request': 'bg-blue-100 text-blue-700',
  'awaiting_payment': 'bg-yellow-100 text-yellow-700',
  'confirmed': 'bg-green-100 text-green-700',
  'cancelled': 'bg-red-100 text-red-700',
  'completed': 'bg-gray-100 text-gray-700',
};

export const statusLabels = {
  'new_request': 'New Request',
  'awaiting_payment': 'Awaiting Payment',
  'confirmed': 'Confirmed',
  'cancelled': 'Cancelled',
  'completed': 'Completed',
};
